// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3b2ht","field":"styles_field__z4BXu","fieldCol":"styles_fieldCol__18GWH","diffCol":"styles_diffCol__2cKsK","diff":"styles_diff__2IvMS"};